import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ThemeStyle } from '../../module/ThemeManager';
import { theme } from '../../constants/theme';
import { LocationDetail, LocationSelector, LocationSelectorProps } from './LocationSelector';

interface ILocationModal extends LocationSelectorProps {
    onBack: () => void;
    themeStyle: ThemeStyle;
    onChange?: (locationDetails: LocationDetail) => void;
    initialSuggestion?: LocationDetail;
}

const LocationModal: React.FC<ILocationModal> = ({ onBack, themeStyle, onChange, initialSuggestion, ...props }) => {
    const handleDone = (locationDetails: LocationDetail) => {
        onChange && onChange(locationDetails);
        onBack();
    };

    return (
        <Box sx={{ width: '100%', flexShrink: 0, height: '500px' }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                <IconButton onClick={onBack} sx={{ color: theme[themeStyle].tag_white }}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h6" style={{ color: theme[themeStyle].tag_white }}>
                    Search A Location
                </Typography>
                <Box />
            </Box>

            <LocationSelector
                onLocationSelect={details => handleDone(details)}
                initialSuggestion={initialSuggestion}
                {...props}
            />
        </Box>
    );
};

export default LocationModal;
